import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { cloudStorageAPI } from "api/api/cloudStorageApi/cloudStorageApi";
import { GetCloudStorageParams, GetCloudStorageResponse } from "api/api/cloudStorageApi/types";

export const getCloudStorage = createAsyncThunk<
  GetCloudStorageResponse,
  GetCloudStorageParams
>("cloudStorage/previews", async (params, { rejectWithValue }) => {
  try {
    const data = await cloudStorageAPI.getCloudStorage(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting photos",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while getting photos", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
